var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',{class:'exportClass ' + _vm.className,attrs:{"type":_vm.type,"size":_vm.size,"disabled":_vm.disabled},on:{"click":_vm.downLoad}},[_vm._v(" "+_vm._s(_vm.text)+_vm._s(_vm.percent)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }